import { escapeForCSV } from '../../../core/utils/download.js';
import { getUnitAsString } from '../../core/utils/get-unit-as-string.js';
import { HistogramSeries, HistogramBin } from '../types/histogram.js';

type BinColumns = keyof HistogramBin;

export function formatCSV(rawData: HistogramSeries[]) {
  const columns = ['name', 'unit', 'from', 'to', 'value'];

  const binsColumns = columns.slice(columns.indexOf('from'));

  let csv = `${columns.join(',')}\n`;

  for (const series of rawData) {
    const sanitizedSeriesName = escapeForCSV(series.name);
    const seriesRow = [sanitizedSeriesName, getUnitAsString(series.unit)];

    for (const bins of series.bins) {
      const binsRow: string[] = [];

      for (let i = 0; i < binsColumns.length; i++) {
        const column: BinColumns = binsColumns[i] as BinColumns;
        const value = bins[column as BinColumns];

        const parsedValue = value?.toString() ?? '';
        binsRow.push(parsedValue);
      }

      csv += `${seriesRow.concat(binsRow).join(',')}\n`;
    }
  }

  return csv;
}
